import { Controller } from '@hotwired/stimulus'
import { performWithCsrfRetry } from 'helpers/csrf'

export default class AutosaveNotes extends Controller {
  static values = {
    url: String,
    responseKind: { type: String, default: 'json' }
  }

  connect() {
    this.element.addEventListener('change', this.inputChanged)
  }

  disconnect() {
    this.element.removeEventListener('change', this.inputChanged)
  }

  inputChanged = event => {
    const target = event.target
    const elementName = target.name

    this.element.querySelectorAll(`[name="${elementName}"]`).forEach(el => el.classList.remove('is-invalid'))

    this.saveChanges()
  }

  saveChanges = () => {
    const data = new FormData(this.element)
    const updateBatchSize = 1

    this.pendingSave = performWithCsrfRetry('patch', this.urlValue, {
      body: data,
      responseKind: this.responseKindValue
    }).then(({ request, response }) => {
        if (response.ok) {
          document.dispatchEvent(new CustomEvent('autosave:success', { detail: { response } }))
        } else if (response.statusCode === 401) {
          // If still unauthorized after Csrf retry, reload page to redirect to proper URL
          window.location.reload()
        } else {
          console.error('SuperForm: autosave failed', response)
          document.dispatchEvent(new CustomEvent('autosave:failed', { detail: { response } }))
        }
      })
      .catch(error => {
        console.error('SuperForm: autosave failed', error)
        document.dispatchEvent(new CustomEvent('autosave:failed', { detail: { error } }))
      })
      .finally(() => {
        this.pendingSave = null
        document.dispatchEvent(new CustomEvent('autosave:completed', { detail: { updateBatchSize } }))
      })

    return this.pendingSave
  }

  finalize = async () => {
    if (this.pendingSave) {
      await this.pendingSave
    }
  }
}

export { AutosaveNotes }
